import { Grid2 as Grid, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { Luogo } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikSelect, FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import { ACLuogo } from "./autocompletes"
import useUserCanWriteAndDelete from "../../hooks/permissions"

export default function LuogoForm({ item, save, ref }: FormInDialogProps<Luogo>) {
  const { t } = useTranslation()
  const userCanWriteAndDelete = useUserCanWriteAndDelete()
  const initialValues = useMemo(() => {
    return (
      item ?? {
        nome: "",
        luogo_padre: null,
      }
    )
  }, [item])

  const schema = useMemo(
    () =>
      yup.object().shape({
        nome: yup.string().required().label(t("donatore.nome")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Luogo).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="nome"
                  label={t("luogo.nome")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>

              <Grid size={6}>
                <Field
                  component={FormikSelect}
                  name="livello_geografico"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  required
                  label={t("luogo.livello_geografico")}
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                >
                  <MenuItem value={"toponimo"}>{t("luogo.enum_livello_geografico.toponimo")}</MenuItem>
                  <MenuItem value={"comune"}>{t("luogo.enum_livello_geografico.comune")}</MenuItem>
                  <MenuItem value={"provincia"}>{t("luogo.enum_livello_geografico.provincia")}</MenuItem>
                  <MenuItem value={"regione"}>{t("luogo.enum_livello_geografico.regione")}</MenuItem>
                  <MenuItem value={"nazione"}>{t("luogo.enum_livello_geografico.nazione")}</MenuItem>
                </Field>
              </Grid>
              <Grid size={12}>
                <ACLuogo
                  label={t("luogo.luogo_padre")}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.luogo_padre as number}
                  onChange={(value) => {
                    setFieldValue("luogo_padre", value)
                  }}
                  
                  // FormComponent={DonatoreForm}
                  // create={createDonatore}
                  // initialCreate={(search) => ({ nome: search })}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
